import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidDialog } from '../../../../mechanics/rid-dialog/rid-dialog';

@Component({
  selector: 'app-dialog-page',
  imports: [RidDialog],
  templateUrl: './dialog-page.html',
})
export class DialogPage {
  protected readonly $router = inject(Router);
}
